import React, { useState } from 'react'

function formatElapsed(totalSec) {
  if (!Number.isFinite(totalSec) || totalSec < 0) totalSec = 0
  const h = Math.floor(totalSec / 3600)
  const m = Math.floor((totalSec % 3600) / 60)
  const s = Math.floor(totalSec % 60)
  const pad = (n) => String(n).padStart(2, '0')
  if (h > 0) return `${h}:${pad(m)}:${pad(s)}`
  return `${pad(m)}:${pad(s)}`
}

function formatDuration(totalSec) {
  if (!Number.isFinite(totalSec) || totalSec < 0) totalSec = 0
  const h = Math.floor(totalSec / 3600)
  const m = Math.floor((totalSec % 3600) / 60)
  if (h === 0) return `${m} min`
  if (m === 0) return `${h} hr`
  return `${h} hr ${m} min`
}

export default function JobTimer({
  isActive,           // is THIS job's timer currently running
  disabled,           // block all interaction
  busy,               // an async op is pending
  elapsedSeconds,     // live elapsed seconds from parent tick
  cancelAllowed,      // show cancel button (first 30s)
  finishedEntry,      // {clock_in, clock_out, hours_worked} most-recent completed for this job by the user today (optional)
  crewNames,          // array of crew member names for summary
  onStart,
  onStop,
  onCancel,
}) {
  const [note, setNote] = useState('')

  const handleStop = () => {
    if (busy || disabled) return
    const n = note.trim()
    onStop(n || null)
    setNote('')
  }

  if (isActive) {
    return (
      <div style={s.wrap}>
        <button
          onClick={handleStop}
          disabled={busy || disabled}
          className="job-timer-pulse"
          style={{ ...s.stopBtn, opacity: (busy || disabled) ? 0.7 : 1 }}
        >
          ■ STOP — {formatElapsed(elapsedSeconds)}
        </button>
        <input
          type="text"
          value={note}
          onChange={e => setNote(e.target.value)}
          placeholder="Add note (optional): 'waited for customer', 'liner wrong size'..."
          style={s.noteInput}
        />
        {cancelAllowed && (
          <button onClick={onCancel} disabled={busy || disabled} style={s.cancelBtn}>
            CANCEL — started by accident
          </button>
        )}
      </div>
    )
  }

  return (
    <div style={s.wrap}>
      <button
        onClick={onStart}
        disabled={busy || disabled}
        style={{ ...s.startBtn, opacity: (busy || disabled) ? 0.5 : 1 }}
      >
        ▶ START JOB
      </button>
      {finishedEntry && finishedEntry.clock_out && (
        <div style={s.summary}>
          <div style={s.summaryTitle}>
            ✓ Job complete — {formatDuration(((new Date(finishedEntry.clock_out) - new Date(finishedEntry.clock_in)) / 1000))}
          </div>
          {crewNames && crewNames.length > 0 && (
            <div style={s.summaryCrew}>
              Crew: {crewNames.join(', ')}
            </div>
          )}
          {finishedEntry.note && <div style={s.summaryNote}>“{finishedEntry.note}”</div>}
        </div>
      )}
    </div>
  )
}

const s = {
  wrap: { display: 'flex', flexDirection: 'column', gap: '8px', marginTop: '12px' },
  startBtn: {
    width: '100%', minHeight: '50px', padding: '14px 16px',
    backgroundColor: '#4a8c6a', border: 'none', borderRadius: '4px',
    color: '#ffffff', fontFamily: "'Barlow Condensed',sans-serif",
    fontSize: '17px', fontWeight: 700, letterSpacing: '2px', cursor: 'pointer',
  },
  stopBtn: {
    width: '100%', minHeight: '50px', padding: '14px 16px',
    backgroundColor: '#c84848', border: '2px solid #e05c5c', borderRadius: '4px',
    color: '#ffffff', fontFamily: "'Barlow Condensed',sans-serif",
    fontSize: '17px', fontWeight: 700, letterSpacing: '2px', cursor: 'pointer',
  },
  noteInput: {
    width: '100%', backgroundColor: 'rgba(255,255,255,0.04)',
    border: '1px solid rgba(255,255,255,0.1)', borderRadius: '3px',
    padding: '10px 12px', color: '#ffffff', fontSize: '14px',
    fontFamily: "'Barlow',sans-serif", outline: 'none', boxSizing: 'border-box',
  },
  cancelBtn: {
    alignSelf: 'flex-start', padding: '6px 12px',
    backgroundColor: 'transparent', border: '1px solid rgba(255,255,255,0.15)',
    borderRadius: '3px', color: 'rgba(255,255,255,0.6)',
    fontFamily: "'Barlow Condensed',sans-serif", fontSize: '11px',
    fontWeight: 600, letterSpacing: '1.5px', cursor: 'pointer',
  },
  summary: {
    backgroundColor: 'rgba(74,140,106,0.08)', border: '1px solid rgba(74,140,106,0.3)',
    borderRadius: '4px', padding: '12px 14px',
  },
  summaryTitle: {
    color: '#4a8c6a', fontFamily: "'Barlow Condensed',sans-serif",
    fontSize: '13px', fontWeight: 700, letterSpacing: '1.5px',
  },
  summaryCrew: {
    marginTop: '4px', color: 'rgba(255,255,255,0.6)', fontSize: '12px',
  },
  summaryNote: {
    marginTop: '6px', color: 'rgba(255,255,255,0.55)', fontSize: '13px',
    fontStyle: 'italic',
  },
}
